import { Box, Tabs } from '@mui/material'
import { APPEARANCE } from './segmentedTabsTokens.js'
import { getSegmentedTabsOuterSx } from './getSegmentedTabsOuterSx.js'
import { getSegmentedTabsTrackSx } from './getSegmentedTabsTrackSx.js'

/**
 * Segmented control built on MUI `<Tabs>`/`<Tab>`. Pill track with a raised
 * active segment; underline indicator hidden in favor of background + shadow.
 */
export default function SegmentedTabs({
  value,
  onChange,
  'aria-label': ariaLabel = 'View',
  maxWidth = 247,
  fullWidth = false,
  appearance = 'default',
  children,
}) {
  const isFullWidth = fullWidth || maxWidth === null
  const { trackBg, trackRadiusPx, trackMinHeight = 34 } = APPEARANCE[appearance] ?? APPEARANCE.default

  return (
    <Box sx={getSegmentedTabsOuterSx(isFullWidth, maxWidth, trackMinHeight)}>
      <Tabs
        value={value}
        onChange={onChange}
        aria-label={ariaLabel}
        slotProps={{ indicator: { sx: { display: 'none' } } }}
        sx={getSegmentedTabsTrackSx(isFullWidth, trackBg, trackRadiusPx, trackMinHeight)}
      >
        {children}
      </Tabs>
    </Box>
  )
}
